import { useTranslation } from 'react-i18next';

const Bajo = ({ lang, eltipo }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    var anchuraimagen = 1680;
    var alturaimagen = 1024;
    if (eltipo == 19) {
        anchuraimagen = 4000;
        alturaimagen = 3000;
    }
    else if (eltipo == 40) {
        anchuraimagen = 1966;
        alturaimagen = 1368;
    }
    else if (eltipo == 41) {
        anchuraimagen = 1680;
        alturaimagen = 1024;
    }
    else if (eltipo == 42) {
        anchuraimagen = 1666;
        alturaimagen = 924;
    }

    return (
        <>
            <section className="u-clearfix u-section-3" id="block-11">
                <div className="u-clearfix u-sheet u-sheet-1"></div>
            </section>
            <section className="u-clearfix u-image u-section-4" id="block-1" data-image-width={anchuraimagen} data-image-height={alturaimagen} style={{ backgroundImage: `url(/images/web/onboard2/${eltipo.nombre.replace(" ", "-")}2.jpg)` }}>
                <div className={`u-clearfix u-sheet u-sheet-1 ${(eltipo.id == 19 || eltipo.id == 42) ? "u-valign-middle-xs" : ""}`}>
                    <h3 className={`u-custom-font u-text u-text-default u-text-font u-text-1 ${(eltipo.id == 19 || eltipo.id == 42) ? "u-text-white" : "u-text-grey-75"} ${(eltipo.id == 40 || eltipo.id == 42) ? "u-align-left" : "u-align-right"}`} > {t("¿No sabes por dónde empezar?")}</h3>
                    <p className={`u-custom-font u-font-montserrat u-text u-text-2 ${(eltipo.id == 19 || eltipo.id == 42) ? "u-text-white" : "u-text-grey-75"} ${(eltipo.id == 40 || eltipo.id==42) ? "u-align-left" : (eltipo.id !=19) ? "u-align-right" : ""}`}>{t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso.")}</p>
                    <a href={"/" + preidioma + t("contacto")} className={`u-border-2 u-border-custom-color-5 u-border-hover-custom-color-5 u-btn u-btn-round u-button-style u-hover-grey-5 u-radius u-text-custom-color-5 u-white u-btn-1 ${(eltipo.id == 19 || eltipo.id == 40 || eltipo.id == 42) ? "u-align-center" : ""}`}> 📩 {t("SOLICITA PRESUPUESTO").toLowerCase().charAt(0).toUpperCase() + t("SOLICITA PRESUPUESTO").toLowerCase().slice(1)}</a>
                </div>
            </section>
        </>
    )
}
export default Bajo;
